module.exports = __webpack_public_path__ + "static/media/infoJumbo3.72ff81c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fanuc/images/infoJumbo3.png
// module id = 588
// module chunks = 0